import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { StoreService } from '@common/services/store.service';
import { CommonDialogsService } from '@common/dialogs/common-dialogs.service';

import { ExternalLogin } from './external-login';
import { CredentialsService } from '../credentials.service';
import {Observable} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'tiwp-login-tecnalia',
  templateUrl: './external-login.component.html',
  styleUrls: ['./external-login.component.scss']
})
export class LoginTecnaliaComponent extends ExternalLogin implements OnInit {
  public get isOnline(): boolean {
    return navigator.onLine === true;
  }

  readonly translationPath = 'login.';

  _isCorrectLogin = false;

  constructor(
    protected router: Router,
    protected store: StoreService,
    protected commonDialog: CommonDialogsService,
    protected credentialsService: CredentialsService,
    protected translate: TranslateService,
    private activatedRoute: ActivatedRoute
  ) {
    super(router, store, commonDialog, credentialsService, translate);
  }

  ngOnInit() {
    this.store.clearStoredUser();

    const code: string = this.activatedRoute.snapshot.queryParams['code'];
    const iss: string = this.activatedRoute.snapshot.queryParams['iss'];
    const sessionState: string = this.activatedRoute.snapshot.queryParams['session_state'];

    if (code && iss && sessionState) {
      this._isCorrectLogin = true;
      console.log('Autenticación de TECNALIA correcta.');
      setTimeout( () => this.validExternalLogin(code, iss, sessionState), 1000 );
    } else {
      this._isCorrectLogin = false;
      console.error('Autenticación de TECNALIA incorrecta.');
      setTimeout( () => this.invalidExternalLogin(), 1000 );
    }
  }

  protected onInvalidLogin(responseData): Observable<any> {
    console.error('Error: Usuario Kayrox no encontrado usando TECNALIA', responseData);

    return super.onInvalidLogin(responseData);
  }
}
